import { FiSearch, FiGift, FiBarChart } from "react-icons/fi";

/**
 * FundingKit menu structure for FOUNDER persona
 * Defines the navigation menu items and sub-items
 */
export const founderMenuItems = [
  {
    menuLabel: "Personal Hub",
    icon: <FiSearch />,
    items: [
      {
        to: "/investors-analysis",
        menuLabel: "Investor Finder",
      },
      {
        to: "/similar-organisations",
        menuLabel: "Similar Organisations",
      },
      {
        to: "/deals",
        menuLabel: "Recent Investments",
      },
    ],
  },
  {
    menuLabel: "Market Intelligence",
    icon: <FiBarChart />,
    items: [
      {
        to: "/industry-pulse",
        menuLabel: "Ecosystem Feed",
      },
      {
        to: "/market-intelligence",
        menuLabel: (
          <>
            Market Signals <sup className="text-[8px] ">BETA</sup>
          </>
        ),
      },
      {
        to: "/research",
        menuLabel: "Market Reports",
      },
      {
        to: "/sector-benchmarks",
        menuLabel: "Funding Distribution",
      },
    ],
  },
  {
    menuLabel: "Upcoming Opportunities",
    icon: <FiGift />,
    items: [
      {
        to: "/call-for-applications",
        menuLabel: "Grants & Call for Applications",
      },
      {
        to: "/events",
        menuLabel: "Conferences & Events",
      },
    ],
  },
];
